/*
*
* 2015 Apollo Theme
*
*/
var responsiveflag = false;
var loadIcon = "//uturnaudio.com/cdn/shop/t/72/assets/loading.gif?v=75299388875687851671763585556";

$(document).ready(function() {
  initApollo();
  //initQuickView();
    //initMobileModals();
    //initWishlist();
  //responsiveResize();
    //productImage();
  //$(window).resize(responsiveResize);
  //responsiveProductZoom();
  /*width_check();
  offCanvas();
  floatHeader();
  floatTopbar();
  backtotop();
  changeFloatHeader();
  changeLayoutMode();
  changeHeaderStyle();
  changeSkinsStyle();*/
  //addFilterEffect();
    //accordionNewletter('disable');
  
    panelTool();
  
    // masony
      /*var $grid = $('.test').isotope({
        itemSelector: '.grid-item',
        percentPosition: true,
        masonry: {
          columnWidth: '.grid-sizer'
        }
      });
      $grid.imagesLoaded().progress( function() {
        $grid.isotope('layout');
      });*/
});
function replaceUrlParam(url, paramName, paramValue) {
    var pattern = new RegExp('('+paramName+'=).*?(&|$)'),
        newUrl = url.replace(pattern,'$1' + paramValue + '$2');
    if ( newUrl == url ) {
        newUrl = newUrl + (newUrl.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
    }
    return newUrl;
}
function initMobileModals(){
  var width = $(window).width();
  if (width < 769){
  $('.mobile-modal').each(function(i, obj){
      $(this).attr('rel', 'modal:open');
      var $popup = $(this).find('.popuptext');
      var $target = $popup.attr('id');
      $(this).attr('href', '#'+$target);
    });
  }
}

function initApollo() {
  $(".swatch :radio").change(function() {
        var t = $(this).closest(".swatch").attr("data-option-index");
        var n = $(this).val();
        $(this).closest("form").find(".single-option-selector").eq(t).val(n).trigger("change")
    });
    $(".hover-bimg").mouseenter(function() {
      $(this).closest('.product-image-container').find('.product_img_link').first().find('img').first().attr('src', $(this).data('bimg'));
  });
    $(".nav-verticalmenu .caret").click(function(e) {
    $(this).closest("li").toggleClass("menu-open");
    e.stopPropagation();
  });
}
function updatePricing() {
    var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
    var unitPriceTextMatch = $('#ProductPrice span').text().match(regex);
    if (!unitPriceTextMatch) {
        regex = /([0-9]+[.|,][0-9]+)/g;
        unitPriceTextMatch = $('#ProductPrice span').text().match(regex);      
    }
    if (unitPriceTextMatch) {
        var unitPriceText = unitPriceTextMatch[0];      
        var unitPrice = unitPriceText.replace(/[.|,]/g,'');
        var quantity = parseInt($('#Quantity').val());
        var totalPrice = unitPrice * quantity;
        var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
        var textPrice = totalPriceText.match(regex);
      totalPriceText = (textPrice && textPrice.length > 0) ? textPrice[0] : "0";
        var regInput = new RegExp(unitPriceText, "g");  
        var totalPriceHtml = $('.product .price').html().replace(regInput ,totalPriceText); 
        $('.product .total-price span').html(totalPriceHtml);
    }
      /*console.log(unitPriceTextMatch);*/

}
function updatePricingQuickView() {
                        
        Currency.convertAll(window.shop_currency, $("#currencies a.selected").data("currency"), "span.money", "money_format")
    
    var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
    var unitPriceTextMatch = jQuery('.quick-view-product .price').text().match(regex);
    if (!unitPriceTextMatch) {
        regex = /([0-9]+[.|,][0-9]+)/g;
        unitPriceTextMatch = jQuery('.quick-view-product .price').text().match(regex);
    }
    if (unitPriceTextMatch) {
        var unitPriceText = unitPriceTextMatch[0];
        var unitPrice = unitPriceText.replace(/[.|,]/g,'');
        var quantity = parseInt(jQuery('.quick-view-product input[name=quantity]').val());
        var totalPrice = unitPrice * quantity;
        var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
        var textPrice = totalPriceText.match(regex);
        totalPriceText = (textPrice && textPrice.length > 0) ? textPrice[0] : "0";
        var regInput = new RegExp(unitPriceText, "g");
        var totalPriceHtml = jQuery('.quick-view-product .price').html().replace(regInput ,totalPriceText);
        jQuery('.quick-view-product .total-price span').html(totalPriceHtml);
    }
}
function updateOptionsInSelector(t, sel) {
    var from = (sel != "quickview") ? "" : ".quick-view-product ";
    switch (t) {
    case 0:
        var n = "root";
        var r = $(from + ".single-option-selector:eq(0)");
        break;
    case 1:
        var n = $(from + ".single-option-selector:eq(0)").val();
        var r = $(from + ".single-option-selector:eq(1)");
        break;
    case 2:
        var n = $(from + ".single-option-selector:eq(0)").val();
        n += " / " + $(from + ".single-option-selector:eq(1)").val();
        var r = $(from + ".single-option-selector:eq(2)")
    }
    var i = r.val();
    r.empty();
    var s = (sel != "quickview") ? Shopify.optionsMap[n] : Shopify.optionsMapQuickview[n];
    if(typeof s != "undefined"){
        for (var o = 0; o < s.length; o++) {
            var u = s[o];
            var a = $("<option></option>").val(u).html(u);
            r.append(a)
        }
    }
    $(from + '.swatch[data-option-index="' + t + '"] .swatch-element').each(function() {
        /*console.log('here');*/
        if ($.inArray($(this).attr("data-value"), s) !== -1) {
            $(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled");
        } else {
            //$(this).addClass("soldout").hide().find(":radio").removeAttr("checked").attr("disabled", "disabled")
        }
    });
    if ($.inArray(i, s) !== -1) {
        r.val(i)
    }
    r.trigger("change")
}
function linkOptionSelectorsQuickview(t) {
    for (var n = 0; n < t.variants.length; n++) {
        var r = t.variants[n];
        if (r.available) {
            Shopify.optionsMapQuickview["root"] = Shopify.optionsMapQuickview["root"] || [];
            Shopify.optionsMapQuickview["root"].push(r.option1);
            Shopify.optionsMapQuickview["root"] = Shopify.uniq(Shopify.optionsMapQuickview["root"]);
            if (t.options.length > 1) {
                var i = r.option1;
                Shopify.optionsMapQuickview[i] = Shopify.optionsMapQuickview[i] || [];
                Shopify.optionsMapQuickview[i].push(r.option2);
                Shopify.optionsMapQuickview[i] = Shopify.uniq(Shopify.optionsMapQuickview[i])
            }
            if (t.options.length === 3) {
                var i = r.option1 + " / " + r.option2;
                Shopify.optionsMapQuickview[i] = Shopify.optionsMapQuickview[i] || [];
                Shopify.optionsMapQuickview[i].push(r.option3);
                Shopify.optionsMapQuickview[i] = Shopify.uniq(Shopify.optionsMapQuickview[i])
            }
        }
    }
    updateOptionsInSelector(0, "quickview");
    if (t.options.length > 1)
        updateOptionsInSelector(1, "quickview");
    if (t.options.length === 3)
        updateOptionsInSelector(2, "quickview");
    $(".single-option-selector:eq(0)").change(function() {
        updateOptionsInSelector(1, "quickview");
        if (t.options.length === 3)
            updateOptionsInSelector(2, "quickview");
        return true
    });
    $(".single-option-selector:eq(1)").change(function() {
        if (t.options.length === 3)
            updateOptionsInSelector(2, "quickview");
        return true
    });
}
function initWishlist(){
    if (window.wishlist_enable) {
        $(".wishlist button.btn-wishlist").click(function(e){
            e.preventDefault();
            var d = $(this).parent();
            $.ajax({
                type:"POST",
                url:"/contact",
                data:d.serialize(),
                beforeSend:function(){

                },
                success:function(n){
                    d.html('<a class="btn btn-outline-inverse btn-wishlist added" href="'+ window.wishlist_url +'"><i class="fa fa-heart"></i><span>Go to Wishlist</span></a>');
                    if (!!$.prototype.fancybox)
                        $.fancybox.open([{
                            type: 'inline',
                            autoScale: true,
                            minHeight: 30,
                            content: '<p class="fancybox-error">' + 'Added to your wishlist.' + '</p>'
                        }], {
                            padding: 0
                        });
                    else
                        alert('Added to your wishlist.');
                },
                error:function(){

                }
            })
        });
    }
}
/*function accordionNewletter(status){
  if(status == 'enable') {
        if(!$('#newsletter_block').hasClass('accordion')){
            $('#newsletter_block .title_block').on('click', function(){
                $(this).toggleClass('active').parent().find('.block_content').stop().slideToggle('medium');
            })
        }
      $('#newsletter_block').addClass('accordion').find('.block_content').slideUp('fast');
  }
  else {
      $('#newsletter_block .title_block').removeClass('active').off().parent().find('.block_content').removeAttr('style').slideDown('fast');
      $('#newsletter_block').removeClass('accordion');
  }
}*/
var product = {};
var currentLinkQuickView = '';
var option1 = '';
var option2 = '';
function setButtonNavQuickview() {
    $("#quickview-nav-button a").hide();
    $("#quickview-nav-button a").attr("data-index", "");
    var listProducts = $(currentLinkQuickView).closest(".slide").find("a.quick-view");
    if(listProducts.length > 0) {
      var currentPosition = 0;
      for(var i = 0; i < listProducts.length; i++) {
          if($(listProducts[i]).data("handle") == $(currentLinkQuickView).data("handle")) {
            currentPosition = i;
            break;
          }
        }
      if(currentPosition < listProducts.length - 1) {
          $("#quickview-nav-button .btn-next-product").show();
          $("#quickview-nav-button .btn-next-product").attr("data-index", currentPosition + 1);
      }
      if(currentPosition > 0) {
          $("#quickview-nav-button .btn-previous-product").show();
          $("#quickview-nav-button .btn-previous-product").attr("data-index", currentPosition - 1);
      }
    }
    $("#quickview-nav-button a").click(function() {
      $("#quickview-nav-button a").hide();
      var indexLink = parseInt($(this).data("index"));
      if(!isNaN(indexLink) && indexLink >= 0) {
          var listProducts = $(currentLinkQuickView).closest(".slide").find("a.quick-view");
          if(listProducts.length > 0 && indexLink < listProducts.length) {
              //$(".quickview-close").trigger("click");
            $(listProducts[indexLink]).trigger("click");
          }
      }
    });
}
function initQuickView(){
  if (window.quickview_enable){
        $(document).on("click", "#thumblist_quickview li", function() {
            changeImageQuickView($(this).find("img:first-child"), "#product-featured-image-quickview");
        });
    $(document).on('click', '.quick-view', function(e){
      var producthandle = $(this).data("handle");
            currentLinkQuickView = $(this);
      Shopify.getProduct(producthandle,function(product) {
        var qvhtml = $("#quickview-modal").html();
        $(".quick-view-product").html(qvhtml);
        var quickview= $(".quick-view-product");
        var productdes = product.description.replace(/(<([^>]+)>)/ig,"");
        var featured_image = product.featured_image;
                //Reset current link quickview and button navigate in Quickview - Disable
                //setButtonNavQuickview();
        productdes = productdes.split(" ").splice(0,30).join(" ")+"...";
        quickview.find(".view_full_size img").attr("src",featured_image);
        quickview.find(".view_full_size img").attr("alt",product.title);
                quickview.find(".view_full_size a").attr("title",product.title);
                quickview.find(".view_full_size a").attr("href",product.url);
                
        quickview.find(".price").html(Shopify.formatMoney(product.price, window.money_format));
                quickview.find(".product-item").attr("id", "product-" + product.id);
                quickview.find(".variants").attr("id", "product-actions-" + product.id);
        quickview.find(".variants select").attr("id", "product-select-" + product.id);

        quickview.find(".product-info .qwp-name").text(product.title);
                quickview.find(".product-info .brand").append("<span>Vendor: </span>" + product.vendor);
                if(product.available){
                    quickview.find(".product-info .availability").append("<p class=\"available instock\">Available</p>");
                }else{
                    quickview.find(".product-info .availability").append("<p class=\"available outstock\">Unavailable</p>");
                }
        quickview.find(".product-info .product-sku").append("<p>Product Code: <span>"+product.variants[0].sku+"</span></p>");
        quickview.find(".product-description").text(productdes);
        
                  
                  
                if (product.compare_at_price > product.price) {
                    quickview.find(".compare-price").html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
                    quickview.find(".price").addClass("on-sale")
                }
                else {
                    quickview.find(".compare-price").html("");
                    quickview.find(".price").removeClass("on-sale")
                }
                if (!product.available) {
                    quickview.find("select, input, .dec, .inc, .variants label").remove();
                    quickview.find(".add_to_cart_detail").text("Sold out").addClass("disabled").attr("disabled", "disabled");
                    $(".quantity_wanted_p").css("display", "none");
                }
                else {
                    quickViewVariantsSwatch(product, quickview);
                }
                $("#quick-view-product").fadeIn(500);
                
                $(".view_scroll_spacer").removeClass("hidden");
                loadQuickViewSlider(product, quickview);
                  
                $(".quick-view").fadeIn(500);
                if ($(".quick-view .total-price").length > 0) {
                    $(".quick-view input[name=quantity]").on("change", updatePricingQuickView)
                }
                updatePricingQuickView();
                // Setup listeners to add/subtract from the input
                $(".js-qty__adjust").on("click", function() {
                    var el = $(this),
                        id = el.data("id"),
                        qtySelector = el.siblings(".js-qty__num"),
                        qty = parseInt(qtySelector.val().replace(/\D/g, ''));
                    var qty = validateQty(qty);
                    // Add or subtract from the current quantity
                    if (el.hasClass("js-qty__adjust--plus")) {
                      qty = qty + 1;
                    } else {
                      qty = qty - 1;
                      if (qty <= 1) qty = 1;
                    }
                    // Update the input's number
                    qtySelector.val(qty);
                    updatePricingQuickView();
                });
                $(".js-qty__num").on("change", function() {
                    updatePricingQuickView();
                });
      });
      return false;
    });
  }
}
function loadQuickViewSlider(n, r) {
    productImage();
    var loadingImgQuickView = $('.loading-imgquickview');
    var s = Shopify.resizeImage(n.featured_image, "grande");
    r.find(".quickview-featured-image").append('<a href="' + n.url + '"><img src="' + s + '" title="' + n.title + '"/><div style="height: 100%; width: 100%; top:0; left:0 z-index: 2000; position: absolute; display: none; background: url(' + window.loading_url + ') 50% 50% no-repeat;"></div></a>');
    if (n.images.length > 0) {
        var o = r.find(".more-view-wrapper ul");
        for (i in n.images) {
            var u = Shopify.resizeImage(n.images[i], "grande");
            var a = Shopify.resizeImage(n.images[i], "compact");
            var f = '<li><a href="javascript:void(0)" data-imageid="' + n.id + '" data-image="' + n.images[i] + '" data-zoom-image="' + u + '" ><img src="' + a + '" alt="Proimage" /></a></li>';
            o.append(f)
        }
        o.find("a").click(function() {
            var t = r.find("#product-featured-image-quickview");
            if (t.attr("src") != $(this).attr("data-image")) {
                t.attr("src", $(this).attr("data-image"));
                loadingImgQuickView.show();
                t.load(function(t) {
                    loadingImgQuickView.hide();
                    $(this).unbind("load");
                    loadingImgQuickView.hide()
                })
            }
        });
        o.owlCarousel({
            navigation: true,
            items: 3,
            itemsDesktop: [1199, 3],
            itemsDesktopSmall: [979, 3],
            itemsTablet: [768, 3],
            itemsTabletSmall: [540, 3],
            itemsMobile: [360, 3]
        }).css("visibility", "visible")
    } else {        
        r.find(".quickview-more-views").remove();
        r.find(".quickview-more-view-wrapper-jcarousel").remove()
    }
}
function updateQuantity(){
  $('.js-qty__adjust').on('click', function() {
    var el = $(this),
      id = el.data('id'),
      qtySelector = el.siblings('.js-qty__num'),
            qty = parseInt(qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if (el.hasClass('js-qty__adjust--plus')) {
          qty = qty + 1;
        } else {
          qty = qty - 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        qtySelector.val(qty);
        updatePricing();
    });
}
validateQty = function (qty) {
    // Make sure we have a valid integer
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };
var convertToSlug = function (e) {
    return e.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
}
var selectCallback = function(variant, selector) {

};
function quickViewVariantsSwatch(t, quickview) {
    if (t.variants.length > 1) {
        for (var r = 0; r < t.variants.length; r++) {
            var i = t.variants[r];
            var s = '<option value="' + i.id + '">' + i.title + "</option>";
            quickview.find("form.variants > select").append(s)
        }
        var ps = "product-select-" + t.id;
        new Shopify.OptionSelectors( ps, { 
            product: t, 
            onVariantSelected: selectCallbackQuickView
        });
        if (t.options.length == 1) {
            $(".selector-wrapper:eq(0)").prepend("<label>" + t.options[0].name + "</label>")
        }
        quickview.find("form.variants .selector-wrapper label").each(function(n, r) {
            $(this).html(t.options[n].name)
        })
        
            var o = window.file_url.substring(0, window.file_url.lastIndexOf("?"));
            var u = window.asset_url.substring(0, window.asset_url.lastIndexOf("?"));
            var a = "";
            for (var r = 0; r < t.options.length; r++) {
                a += '<div class="swatch clearfix" data-option-index="' + r + '">';
                a += '<div class="header">' + t.options[r].name + "</div>";
                var f = false;
                if (/Color|Colour/i.test(t.options[r].name)) { f = true }
                var l = new Array;
                for (var c = 0; c < t.variants.length; c++) {
                    var i = t.variants[c]; var h = i.options[r];
                    var p = this.convertToSlug(h);
                    var d = "quickview-swatch-" + r + "-" + p;
                    if (l.indexOf(h) < 0) {
                        a += '<div data-value="' + h + '" class="swatch-element ' + (f ? "color " : "") + p + (i.available ? " available " : " soldout ") + '">';
                        if (f) {
                            a += '<div class="tooltip">' + h + "</div>"
                        }
                        a += '<input id="' + d + '" type="radio" name="option-' + r + '" value="' + h + '" ' + (c == 0 ? " checked " : "") + (i.available ? "" : " disabled") + " />";
                        if (f) {
                            a += '<label class="'+ p +'" for="' + d + '" style="background-color: ' + p + "; background-image: url(" + u + p + '.png)"><img class="crossed-out" src="' + u + 'soldout.png" /><i></i></label>'
                        }
                        else {
                            a += '<label class="'+ p +'" for="' + d + '">' + h + '<img class="crossed-out" src="' + u + 'soldout.png" /></label>'
                        }
                      /*console.log(o + ':' + p);*/
                        a += "</div>";
                        if (i.available) {
                            $('.quick-view .swatch[data-option-index="' + r + '"] .' + p).removeClass("soldout").addClass("available").find(":radio").removeAttr("disabled")
                        } l.push(h)
                    }
                } a += "</div>"
            }
            quickview.find("form.variants > select").after(a);
            quickview.find(".swatch :radio").change(function () {
                var t = $(this).closest(".swatch").attr("data-option-index");
                var q = $(this).val();
                $(this).closest("form").find(".single-option-selector").eq(t).val(q).trigger("change");

            });
          if (t.available) {
                Shopify.optionsMapQuickview = {};
                linkOptionSelectorsQuickview(t);
            }
            addCheckedSwatch();
        
    }
    else {
        quickview.find("form.variants > select").remove();
        var v = '<input type="hidden" name="id" value="' + t.variants[0].id + '">';
        quickview.find("form.variants").append(v)
    }
}
$(document).on('click', '.quick-view', function(e){
  e.preventDefault();
});
$(document).on('click', '.quickview-close, #quick-view-product .quickview-overlay', function(e){
  $("#quick-view-product").fadeOut(500);
});
function displayImage(domAAroundImgThumb)
{
  if (domAAroundImgThumb.attr('href'))
  {
    var new_src = domAAroundImgThumb.attr('href').replace('1024x1024', 'large');
    var new_title = domAAroundImgThumb.attr('title');
    var new_href = domAAroundImgThumb.attr('href');
    if ($('#bigpic').attr('src') != new_src)
    {
      $('#bigpic').attr({
        'src' : new_src,
        'alt' : new_title,
        'title' : new_title
      });
    }
    $('#views_block li a').removeClass('shown');
    $(domAAroundImgThumb).addClass('shown');
  }
}
/*function productZoom(status){
    if(status == 'enable') {
      $("#proimage").elevateZoom({
            
            zoomType: "inner",
            cursor: 'crosshair',
            zoomWindowPosition: 1, 
          
            responsive: true,
            gallery:'thumbs_list', 
            galleryActiveClass: 'active', 
            imageCrossfade: true,
            scrollZoom : false,
            onImageSwapComplete: function() {
                $(".zoomWrapper div").hide()
            },
            loadingIcon: loadIcon
        });
        $("#proimage").bind("click", function(e) {
            var ez = $('#proimage').data('elevateZoom');  
            $.fancybox(ez.getGalleryList()); 
            return false; 
        });
    }
    else{
      $(document).on('click', '#thumblist .thumb_item a', function(){
            if ($(this).attr('href'))
            {
                var new_src = $(this).data('image');
                var new_title = $(this).attr('title');
                var new_href = $(this).attr('href');
                if ($('#proimage').attr('src') != new_src)
                {
                    $('#proimage').attr({
                        'src' : new_src,
                        'alt' : new_title,
                        'title' : new_title
                    });
                }
            }
        });
    }

}*/
/*function productImage() {
  if ($('#thumblist')){
    var count = $('#thumblist > div').length;
    $('#thumblist').owlCarousel({
      items : (count >=4 ? 4 : count),
      loop: false,
      nav:true,
      mouseDrag: false,
      autoplay: false,
      dots: false,
      navText: [
        "<i class='fa fa-chevron-left fa-1x'></i>",
        "<i class='fa fa-chevron-right fa-1x'></i>"
      ],
      margin: 10,
      responsiveClass: true,
      responsive:{
        0:{
          items:3
        },
        400:{
          items:count, 
          nav: true
        },           
        900:{
          items:count, 
          nav: true
        }
      }
    });
  }

    $('.thumbs_list_frame').height(parseInt($('.thumbs_list_frame >li').outerHeight(true) * $('.thumbs_list_frame >li').height) + 'px');
    $('.thumbs_list').serialScroll({
        items:'li:visible',
        prev:'.view_scroll_left',
        next:'.view_scroll_right',
        axis:'y',
        start:0,
        stop:true,
        duration:700,
        step: 2,
        lazy: true,
        lock: false,
        force:false,
        cycle:false
    });
  if (!!$.prototype.fancybox){
    $('li:visible .fancybox, .fancybox.shown').fancybox({
      'hideOnContentClick': true,
      'openEffect'  : 'elastic',
      'closeEffect' : 'elastic'
    });
  }
}*/
function scrollCompensate() 
{
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";

    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;
    if (w1 == w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    return (w1 - w2);
}
function responsiveResize()
{
  compensante = scrollCompensate();
  if (($(window).width()+scrollCompensate()) <= 767 && responsiveflag == false)
  {
        
          accordion('enable');
        
      accordionFooter('enable');
    responsiveflag = true;  
  }
  else if (($(window).width()+scrollCompensate()) >= 768)
  {
    accordion('disable');
    accordionFooter('disable');
      responsiveflag = false;
  }
}
function responsiveProductZoom()
{
  /*if (($(window).width()) >= 992){
      productZoom('enable');
    }
    else if (($(window).width()) <= 991){
      productZoom('disable');
    }*/
}
function offCanvas(){
  $(window).resize(function(){
  width_check();
  });
  
}
function width_check(){
  if (($(window).width()) <= 991){
    $('[data-toggle="offcanvas"]').click(function (event) {
      var menuCanvas = $(this).data('target');
      $(this).toggleClass('open');
      $(menuCanvas).toggleClass('active');
      $('body').toggleClass('off-canvas-active');
      var heightCanvas = $(window).height();
      $(menuCanvas).css({'min-height' : heightCanvas});
      event.stopPropagation();
    });
    $('.off-canvas-nav').click(function () {
      $('[data-toggle="offcanvas"]').click();
    });
    $('#page').click(function(){
      if ($('body').hasClass('off-canvas-active')){
        $('[data-toggle="offcanvas"]').click();
      }
    });
  }
}
function accordion(status)
{
  leftColumnBlocks = $('#left_column');
  if(status == 'enable')
  {
        if(!$('#left_column').hasClass('accordion')){
          $('#left_column .block .title_block').on('click', function(){
          $(this).toggleClass('active').parent().find('.block_content').stop().slideToggle('medium');
        });
        }
        if(!$('#right_column').hasClass('accordion')){
          $('#right_column .block .title_block').on('click', function(){
          $(this).toggleClass('active').parent().find('.block_content').stop().slideToggle('medium');
        });
        }
        $('#left_column').addClass('accordion').find('.block .block_content').slideUp('fast');
      $('#right_column').addClass('accordion').find('.block .block_content').slideUp('fast');
  }
  else
  {
      $('#right_column .block .title_block, #left_column .block .title_block').removeClass('active').off().parent().find('.block_content').removeAttr('style').slideDown('fast');
      $('#left_column, #right_column').removeClass('accordion');
  }
}
function accordionFooter(status){
  if(status == 'enable') {
        if(!$('#footercenter').hasClass('accordion')){
            $('#footercenter .footer-block h4').on('click', function(){
                $(this).toggleClass('active').parent().find('.block_content').stop().slideToggle('medium');
            })
        }
      $('#footercenter').addClass('accordion').find('.block_content').slideUp('fast');
  }
  else {
      $('.footer-block h4').removeClass('active').off().parent().find('.block_content').removeAttr('style').slideDown('fast');
      $('#footercenter').removeClass('accordion');
  }
}
function processFloatHeader(headerAdd, scroolAction){
  if(headerAdd){
    $("#header").addClass( "navbar-fixed-top" );
      $("#page").css( "padding-top", $("#header").height());
      var hideheight =  $("#header").height()+120;
      var pos = $(window).scrollTop();
      if( scroolAction && pos >= hideheight ){
          $("#topbar").addClass('hide-bar');
          $(".hide-bar").css( "margin-top", - $("#topbar").height() );
            $(".header-container").addClass("mini-bar");
      }else {
          $("#topbar").css( "margin-top", 0 );
            $(".header-container").removeClass("mini-bar");
      }
  }else{
    $("#header").removeClass( "navbar-fixed-top" );
      $("#page").css( "padding-top", '');
        $("#header-main").removeClass('hidden');
        $("#apollo-menu").removeClass('hidden');
        $("#topbar").css( "margin-top", 0 );

  }
  
}
function processFloatTopbar(topbarAdd, scroolAction){
  if(topbarAdd){
    $("#header").addClass( "navbar-fixed-top" );
      $("#page").css( "padding-top", $("#header").height());
      var hideheightBar =  $("#header").height()+120;
      var pos = $(window).scrollTop();
      if( scroolAction && pos >= hideheightBar ){
          $("#header-main").addClass('hidden');
      $("#apollo-menu").addClass('hidden');
      }else {
          $("#header-main").removeClass('hidden');
          $("#apollo-menu").removeClass('hidden');
      }
  }else{
    $("#header").removeClass("navbar-fixed-top");
      $("#page").css( "padding-top", '');
      $("#header-main").removeClass('hidden');
      $("#apollo-menu").removeClass('hidden');
        $("#topbar").css( "margin-top", 0 );
  }

}
function floatHeader(){
  $(window).resize(function(){
    if (!$("body").hasClass("keep-header") || $(window).width() <= 990){
      return;
    }
    if ($(window).width() <= 990)
    {
      processFloatHeader(0,0);
    }
    else if ($(window).width() > 990)
    {
      if ($("body").hasClass("keep-header"))
        processFloatHeader(1,1);
    }
  });
    $(window).scroll(function() {
      if (!$("body").hasClass("keep-header")) return;
      if($(window).width() > 990){
           processFloatHeader(1,1);

      }
    });
}
function floatTopbar(){
  $(window).resize(function(){
    if (!$("body").hasClass("keep-topbar") || $(window).width() <= 990){
      return;
    }
    if ($(window).width() <= 990)
    {
      processFloatTopbar(0,0);
    }
    else if ($(window).width() > 990)
    {
      if ($("body").hasClass("keep-topbar"))
        processFloatTopbar(1,1);
    }
  });
    $(window).scroll(function() {
      if (!$("body").hasClass("keep-topbar")) return;
      if($(window).width() > 990){
           processFloatTopbar(1,1);

      }
    });
}
function backtotop(){
  $("#back-top").hide();
  $(function () {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('#back-top').fadeIn();
      } else {
        $('#back-top').fadeOut();
      }
    });
    $('#back-top a').click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 800);
      return false;
    });
  });
}
function panelTool(){
  $('#paneltool .panelbutton').click(function(){
    $('#paneltool .paneltool').toggleClass('active');
  });
}
function changeFloatHeader(){
  $('#floatHeader').click(function(){
    if ($('body').hasClass('keep-header')) {
      $('body').removeClass('keep-header');
      processFloatHeader(0,0);
    }
    else{
      processFloatTopbar(0,0);
      $('body').addClass('keep-header');
      $('body').removeClass('keep-topbar');
      $("#floatTopbar").prop("checked", false);
    };
  });
  $('#floatTopbar').click(function(){
    if ($('body').hasClass('keep-topbar')) {
      $('body').removeClass('keep-topbar');
      processFloatTopbar(0,0);
    }
    else{
      processFloatHeader(0,0);
      $('body').addClass('keep-topbar');
      $('body').removeClass('keep-header');
      $("#floatHeader").prop("checked", false);
    };
  });
}
function changeLayoutMode(){
    $('.dynamic-update-layout').click(function(){
        var currentLayoutMode = $('.dynamic-update-layout.selected').data('layout-mode');
        if(!$(this).hasClass('selected'))
        {
            $('.dynamic-update-layout').removeClass('selected');
            $(this).addClass('selected');
            selectedLayout = $(this).data('layout-mode');
            $('body').removeClass(currentLayoutMode);
            $('body').addClass(selectedLayout);
        }
    });
}
function changeSkinsStyle(){
    $('.dynamic-update-skins').click(function(){
        var currentSkins = $('.dynamic-update-skins.selected').data('skins');
        if(!$(this).hasClass('selected'))
        {
            $('.dynamic-update-skins').removeClass('selected');
            $(this).addClass('selected');
            selectedSkins = $(this).data('skins');
            $('body').removeClass(currentSkins);
            $('body').addClass(selectedSkins);
        }
    });
}
function changeHeaderStyle(){
    $('.dynamic-update-header').click(function(){
        var currentHeaderMode = $('.dynamic-update-header.selected').data('header-style');
        if(!$(this).hasClass('selected'))
        {
            $('.dynamic-update-header').removeClass('selected');
            $(this).addClass('selected');
            selectedHeaderStyle = $(this).data('header-style');
            $('body').removeClass(currentHeaderMode);
            $('body').addClass(selectedHeaderStyle);
        }
    });
}
function addCheckedSwatch(){  
    $('.swatch .color label').on('click', function () {      
        $('.swatch .color').each(function(){      
            $(this).find('label').removeClass('checkedBox');
        });
        $(this).addClass('checkedBox');
    });
}
function SetOwlCarouselFirstLast(el){
    el.find(".owl-item").removeClass("first");
    el.find(".owl-item.active").first().hide();
    el.find(".owl-item.active").first().addClass("first");
    el.find(".owl-item").removeClass("last");
    el.find(".owl-item.active").last().addClass("last");
}
function activeParentMenu(){
  $('.megamenu').find('li.active').first().each(function(){
    addClassActive($(this).parent().closest('li'));
  });
}
function addClassActive(e){
  $(e).addClass('active');
  if(!$(e).parent().hasClass('megamenu')){
    addClassActive($(e).parent().closest('li'));
  }
}
/*START LEFT- RIGHT MENU*/
function setLeftColumn() {
    if($("#left_column").length > 0) {
        if($(".over-cover").length == 0) {
            $('body').append($('<div class="over-cover"></div><div class="drag-target-left"><div class="drag-panel-left"></div></div>'));
            $('body').append($('<a href="javascript:;" data-activates="slide-out" class="button-collapse-left"><i class="mdi-navigation-menu"></i></a>'));
        }

        $(".button-collapse-left").click(function() {
            $(".drag-target-left, .button-collapse-left").addClass("hide");
            $("body").addClass("move-left-to-right");
            $('#left_column').css("left", "-400px");
            setTimeout(function() {
                $("#left_column").parent().addClass("side-nav-container-left");
                $("#left_column").addClass("side-nav-left");
            }, 200);
        });
        $(".over-cover").click(function() {
            $(".drag-target-left, .button-collapse-left").removeClass("hide");
            $("#left_column").parent().removeClass("side-nav-container-left");
            $("#left_column").removeClass("side-nav-left");
            $("body").removeClass("move-left-to-right");
            $(".box-left-menu").addClass("menu-close");
            $('#left_column').css("left", "");
        });
        $(".drag-target-left").click(function() {
            /*console.log("drag-target click");*/
            $(".button-collapse-left").trigger("click");
        });
    }
}
function setRightColumn() {
    if($("#right_column").length > 0) {
        if($(".over-cover").length == 0) {
            $('body').append($('<div class="over-cover"></div><div class="drag-target-right"><div class="drag-panel-right"></div></div>'));
            $('body').append($('<a href="javascript:;" data-activates="slide-out" class="button-collapse-right"><i class="mdi-navigation-menu"></i></a>'));
        }

        $(".button-collapse-right").click(function() {
            $(".drag-target-right, .button-collapse-right").addClass("hide");
            $("body").addClass("move-right-to-left");
            $('#right_column').css("right", "-400px");
            setTimeout(function() {
                $("#right_column").parent().addClass("side-nav-container-right");
                $("#right_column").addClass("side-nav-right");
            }, 200);
        });
        $(".over-cover").click(function() {
            $(".drag-target-right, .button-collapse-right").removeClass("hide");
            $("#right_column").parent().removeClass("side-nav-container-right");
            $("#right_column").removeClass("side-nav-right");
            $("body").removeClass("move-right-to-left");
            $(".box-right-menu").addClass("menu-close");
            $('#right_column').css("right", "");
        });
        $(".drag-target-right").click(function() {
            /*console.log("drag-target click");*/
            $(".button-collapse-right").trigger("click");
        });
    }
}
/*END LEFT- RIGHT MENU*/

/*PRELOAD IMAGES*/
function preload(arrayOfImages) {
    $(arrayOfImages).each(function(){
        $('<img/>')[0].src = this;
        // Alternatively you could use:
        // (new Image()).src = this;
    });
    console.log('preloaded');
}